// Export my data — CLAUDE.md §4 / Qatar PDPL portability.
//
// Scope is set SERVER-side and is deliberately narrow: the caller's own
// account, their own children's minimal records, and their own billing
// history. Never another family's data. This component only renders the
// result to a file; it must not widen the request.

import { useT } from '@fajrarabi/i18n/react';
import { Alert, Button } from '@fajrarabi/ui';
import { useMutation } from '@tanstack/react-query';

import { AccountSection } from './AccountSection';

import { downloadJson, exportAccountData } from '~/lib/account';

export function ExportDataCard() {
  const t = useT();

  const mutation = useMutation({
    mutationFn: () => exportAccountData(),
    onSuccess: (data) => {
      const stamp = new Date().toISOString().slice(0, 10);
      downloadJson(data, `fajrarabi-my-data-${stamp}.json`);
    },
  });

  return (
    <AccountSection
      id="account-export"
      title={t('app.account.export_title')}
      description={t('app.account.export_description')}
    >
      {mutation.error && <Alert tone="danger">{t('app.account.export_error')}</Alert>}
      {mutation.isSuccess && <Alert tone="success">{t('app.account.export_ready')}</Alert>}

      <div className="flex justify-end">
        <Button variant="secondary" onClick={() => mutation.mutate()} disabled={mutation.isPending}>
          {t('app.account.export_button')}
        </Button>
      </div>
    </AccountSection>
  );
}
